import React from 'react';
import { Heading, StandardHeadingProps } from '@99designs/emu';

export function ViewFieldHeading({ accessibilityLevel = 3, ...props }: StandardHeadingProps) {
    return <Heading accessibilityLevel={accessibilityLevel} appearanceLevel={5} {...props} />;
}
